export default __webpack_public_path__ + "static/media/product12.a1f329da.png";